import React from 'react'
import styles from './TourDisplay.module.scss'

const TourDisplay = (data) => {
	return (
		<div className={styles.tourDisplayContainer}>
			<span className={styles.tourName}>{data.tourName}</span>
			<span className={styles.caddieName}>{data.caddieName}</span>
			<span className={styles.tourDate}>{data.tourDate}</span>
		</div>
	)
}

export default TourDisplay
